function getLangPath(node, defaultLang = 'is') {
  let langPath = '';

  if (!node) {
    return langPath;
  }

  if (node._meta && node._meta.lang && node._meta.lang.toLocaleLowerCase() !== defaultLang) {
    langPath = `/${node._meta.lang.toLocaleLowerCase().replace('en-us', 'en')}`; // TODO more elegant way?
  }

  return langPath;
}


function getLang(lang) {
  const defaultLang = 'is';
  let langPath = '';

  if (lang.toLocaleLowerCase() !== defaultLang) {
    langPath = `/${lang.toLocaleLowerCase().replace('en-us', 'en')}`;
  }

  return langPath;
}

module.exports = {
  getLangPath,
  getLang,
};
